import React from 'react';
import clsx from 'clsx';
import { getScopeLabel } from '@utils/referenceCatalog';
import styles from './ScopeBadge.module.css';

export interface ScopeBadgeProps {
  scope: 'include' | 'exclude' | 'n/a' | null | undefined;
  className?: string;
}

const ScopeBadge: React.FC<ScopeBadgeProps> = ({ scope, className }) => {
  if (!scope || scope === 'n/a') {
    return <span className={clsx(styles.scopeBadge, styles.scopeBadgeNa, className)}>N/A</span>;
  }

  return (
    <span
      className={clsx(
        styles.scopeBadge,
        scope === 'include' && styles.scopeBadgeInclude,
        scope === 'exclude' && styles.scopeBadgeExclude,
        className
      )}
    >
      {getScopeLabel(scope)}
    </span>
  );
};

export default ScopeBadge;
